module.exports = __webpack_public_path__ + "img/img23.8f5e4085.png";